import React from 'react';
import { BarChart3, ChefHat, Users, ClipboardCheck, Truck, Laptop, TrendingUp, Database } from 'lucide-react';
import '../../styles/ServicesGrid.css';
import digital from '../../assets/digitaloriginal.jpeg';
import supplychain from '../../assets/supply chain2.jpg';
// import digitalbrand from '../../assets/digitalbrand.png';
import Technology from '../../assets/Technology.jpeg';
import operation from '../../assets/operation.webp';
import { Description } from '@radix-ui/react-dialog';

const ServicesGrid = () => {
  const services = [
    {
      icon: <BarChart3 size={40} />,
      title: 'Workflow & SOP Systems',
      images: 
      [ operation ,
        // 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop'
      ],
      description:'Peak-ready structures teams can follow consistently.',
    },
    {
      icon: <ChefHat size={40} />,
      title: 'Cost & Margin Visibility',
      images: [
        // kitchen ,
        'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1577219491135-ce391730fb2c?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=300&fit=crop'
      ],
      description:'Financial clarity that protects profitability.',
    },
    {
      icon: <Laptop size={40} />,
      title: 'POS & Reporting Alignment',
      images: [ Technology,
        // 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=400&h=300&fit=crop'
      ],
      description:'Systems configured to reflect operational reality.',
    },
    {
      icon: <Database size={40} />,
      title: 'Performance Metrics',
      images: [
        // 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
        'https://images.unsplash.com/photo-1543286386-713bdd548da4?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop'
      ],
      description:'Only the signals that actually drive decisions.',
    },
    {
      icon: <Users size={40} />,
      title: 'Growth Infrastructure',
      images: [
        'https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=400&h=300&fit=crop',
      //   'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=400&h=300&fit=crop',
      //   'https://images.unsplash.com/photo-1552664730-d307ca884978?w=400&h=300&fit=crop'
      ],
      description:'Operations built to support expansion — not strain under it.',
    },
    {
      icon: <TrendingUp size={40} />,
      title: 'Digital Growth Execution',
      images: [digital
        // digital ,
        // 'https://images.unsplash.com/photo-1571677246347-5040036b95cc?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
        // 'https://images.unsplash.com/photo-1557838923-2985c318be48?w=400&h=300&fit=crop'
      ],
      description:'Every system exists for one reason: to create control, protect margins, and reduce founder dependency.',
    }
  ];

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        <h4 className='philosophy-tag'>Operational Systems We Build</h4>
        <h2 className="section-title">Designed for Real-World Hospitality Execution</h2>
        {/* <p className="section-subtitle">
          We specialize in bespoke, end-to-end solutions from concept development to strategic operations,
          ensuring your hospitality project excels at every stage.
        </p> */}

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-images">
                {service.images.map((img, idx) => (
                  <div key={idx} className="service-image">
                    <img src={img} alt={service.title} loading="lazy" />
                  </div>
                ))}
              </div>
              <div className="service-content">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                {service.description && (
                  <p className="service-description">{service.description}</p>
                )}
              </div>
            </div>
            
          ))}
        </div> 
      </div>
      <div className="wc-highlight-box">
            {/* <div className="highlight"> */}
        Most consultants tell you what's wrong. We fix it — and we stay until it holds
      </div>
      {/* </div> */}
    </section>
    
  );
};

export default ServicesGrid;